<template>
    <IndexBase @auth="onAuth($event)" :action="ChangeShipmentStatus" :controller="Shipment"></IndexBase>

    <Card>
        <template #title>
            Change Shipment Status
        </template>
        <template #content>
            <div class="p-inputtext-sm">
                <div class="p-fluid">
                    <div class="grid">
                        <div class="col-12">
                             <FormField :labelName="$t('shipment_no')" fieldName="shipmentStatus" v-model="shipmentNo" :skeleton="false" fieldClass="col-6" labelClass="col-4">
                                <InputText :placeholder="$t('shipment_no')" name="shipmentStatus" v-model="shipmentNo" type="text"/>
                            </FormField>

                            <FormField :labelName="$t('status')" fieldName="shipmentStatus" v-model="shipmentStatus" :skeleton="false" fieldClass="col-6" labelClass="col-4">
                                <CustomDropdown :placeholder="$t('status')" v-model="shipmentStatus" :options="shipmentStatusList" >
                                </CustomDropdown>
                            </FormField>

                        </div>
                        <div class="col-12">
                            <FormField :labelName="''" fieldName="shipmentStatus" v-model="shipmentStatus" :skeleton="false" fieldClass="col-2" labelClass="col-4">
                                <Button icon="pi pi-save" label="Change Status" class="p-button-success" @click="onChangeStatus" />
                            </FormField>
                            
                        </div>
                       
                        
                    </div>
                </div>
            </div>
        </template>
    </Card>

   
</template>

<script>
    export default {
        name: "Shipment",
        data() {
            return {
                shipmentNo: "",
                shipmentStatus: "",
                loading:false,
                url: this.$API_URL + "shipment/change_shipment_status",
                shipmentStatusList:[
                    {id: this.$SHIPMENT_STATUS.NEW, text: this.$SHIPMENT_STATUS.NEW },
                    {id: this.$SHIPMENT_SUB_STATUS.REGISTRATION_IN, text: this.$SHIPMENT_SUB_STATUS.REGISTRATION_IN},
                    {id: this.$SHIPMENT_SUB_STATUS.REGISTRATION_OUT, text: this.$SHIPMENT_SUB_STATUS.REGISTRATION_OUT}
                ]
            }
        },
        methods: {
            onChangeStatus(){
                this.$emit('block-ui');
                var self = this;

                if(!this.shipmentNo){
                    self.showError("Shipment No. is required");
                    return;
                }

                if(!this.shipmentStatus){
                    self.showError("Shipment Status is required");
                    return;
                }

                var data = {
                    Shipment_No: this.shipmentNo,
                    Progress_Status: this.shipmentStatus
                };

                this.$axios.put(this.url, data)
                    .then((response) => {
                        if(response.data.success){
                            self.$toast.add({ severity: "success", summary: "Success", detail: response.data.message, life: 120000});
                           
                        }
                        else{
                            self.showError(response.data.message);
                        }
                        self.$emit("unblock-ui");
                    })
                    .catch((error) => {
                        self.showError(error);
                    })


            },
            showError(message){
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: "Error", detail: message, life: 120000});
            }
        },
        mounted() {
            this.$emit('unblock-ui');
            
        },
    }
</script>

<style #scoped>
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }
</style>